<template>
  <div class="row">
    <div class="col-md-12">
      <div v-if="step == 6 && signatureUserSent">
        <div class="row justify-content-center">
          <div class="col-10 col-sm-10 col-md-9 col-lg-6">
            <p class="text-title">
              {{ signatureUserSent.signature_batch.name }}
            </p>

            <MultipleSignaturesTable v-if="multiple" :signatureUserSent="signatureUserSent"/>

            <p class="text">
              Prezado(a)
              <span>{{ signatureUserSent.user.name }}</span
              >!
            </p>

            <p class="text">
              Clique sobre o nome dos documentos abaixo, leia-os, e clique no
              botão Assinar, ao fim da página:
            </p>

            <p
              class="text"
              v-for="sign in signatureUserSents"
              :key="sign.id"
              @click="getPdfUnit(sign)"
              style="cursor: pointer"
            >
              <i class="far fa-file-pdf red"></i>
              <span>{{ sign.document_name }}</span>
            </p>
          </div>
        </div>
        <div class="row justify-content-center" v-if="openViewPDF">
          <div class="col-12 col-sm-12 col-md-6 centered">
            <div class="row">
              <div class="col-5 offset-1">
                <button
                  class="item btn btn-danger btn-block"
                  @click="scale -= scale > 0.2 ? 0.1 : 0"
                >
                  <i class="fa fa-search-minus"></i>
                </button>
              </div>
              <div class="col-5">
                <button
                  class="item btn btn-primary btn-block"
                  @click="scale += scale < 2 ? 0.1 : 0"
                >
                  <i class="fa fa-search-plus"></i>
                </button>
              </div>
            </div>
            <div style="overflow-y: scroll; overflow-x: scroll" width="100%">
              <pdf
                :key="componentKey"
                v-if="openViewPDF"
                :src="viewDoc.document_http"
                :page="page"
                style="width: 100%"
                :scale.sync="scale"
              ></pdf>
            </div>
            <div class="row">
              <div class="col-5 offset-1">
                <button
                  class="item btn btn-secondary btn-block"
                  @click="page -= 1"
                  :disabled="page - 1 == 0"
                >
                  <i class="fa fa-caret-left"></i>
                </button>
              </div>
              <div class="col-5">
                <button
                  class="item btn btn-secondary btn-block"
                  @click="page += 1"
                  :disabled="page == numPages"
                >
                  <i class="fa fa-caret-right"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="row justify-content-center mb-5 mt-4">
          <div class="col-10 col-sm-10 col-md-4 col-lg-4" v-if="readDocuments">
            <div class="alert alert-danger" role="alert">
              Você precisa visualizar todos os documentos para conseguir
              assinar. <br />
              <br />
              Você já visualizou {{ count }} de
              {{ signatureUserSents.length }} documento(s).
            </div>
          </div>
          <div class="col-10 col-sm-10 col-md-4 col-lg-4" v-else>
            <div class="alert alert-success" role="alert">
              Você visualizou todos os documentos, clique em Assinar para
              finalizar o processo
            </div>
          </div>
        </div>
        <div class="row justify-content-center mb-5 mt-4">
          <div class="col-10 col-sm-10 col-md-4 col-lg-2">
            <button
              class="btn btn-sign white"
              :disabled="readDocuments"
              @click="sign"
            >
              <i class="fas fa-file-signature"></i>Assinar
            </button>
          </div>
        </div>
      </div>
      <div class="centered" v-if="step == 0">
        <div class="message">
          <h1>Documento não encontrado</h1>
        </div>
      </div>
      <div class="centered" v-if="step == 99">
        <div class="message">
          <h1>Documento cancelado</h1>
          <h3 class="text-danger">Motivo: {{ canceled_reason }}</h3>
        </div>
      </div>
      <div v-if="step == 1 && signatureUserSent">
        <div class="row justify-content-center">
          <div class="col-10 col-sm-10 col-md-9 col-lg-6">
            <p class="text-title">
              {{ signatureUserSent.signature_batch.name }}
            </p>
            <p class="text">
              Prezado(a)
              <span>{{ signatureUserSent.user.name }}</span
              >!
            </p>
            <p class="text">
              Favor informar os dados abaixo para assinar o documento:
            </p>
            <p class="text">
              <i class="far fa-file-pdf red"></i>
              <span>{{ getDocumentName(signatureUserSent.document) }}</span>
            </p>
          </div>
        </div>
        <div class="row justify-content-center">
          <div class="col-10 col-sm-10 col-md-7 col-lg-4">
            <div class="form-group">
              <label>CPF</label>
              <input
                type="text"
                class="form-control"
                v-model="confirm.cpf"
                v-mask="'###.###.###-##'"
                inputmode="numeric"
              />
            </div>
          </div>
        </div>
        <div class="row justify-content-center">
          <div class="col-10 col-sm-10 col-md-7 col-lg-4">
            <div class="form-group">
              <label>Data de Nascimento</label>
              <!-- <datetime
                v-model="confirm.birthDate"
                class="form-control"
                :phrases="{ok: 'Ok', cancel: 'Cancelar'}"
                value-zone="America/Sao_Paulo"
                zone="America/Sao_Paulo"
              ></datetime>-->
              <input
                class="form-control"
                type="text"
                v-mask="'##/##/####'"
                v-model="confirm.birthDate"
              />
            </div>
          </div>
        </div>
        <div class="row justify-content-center">
          <div class="col-10 col-sm-10 col-md-4 col-lg-2">
            <button class="btn btn-sign white" @click="generateToken()">
              <i class="fas fa-spinner"></i>Gerar Token
            </button>
          </div>
        </div>
      </div>
      <div v-if="step == 2 && signatureUserSent">
        <div class="row justify-content-center">
          <div class="col-10 col-sm-10 col-md-9 col-lg-6">
            <p class="text-title">
              {{ signatureUserSent.signature_batch.name }}
            </p>
            <p class="text">
              Prezado(a)
              <span>{{ signatureUserSent.user.name }}</span
              >!
            </p>
            <p class="text">
              Favor informar o número do Token, enviado no seu e-mail:
            </p>
          </div>
        </div>
        <div class="mt-5 mb-4 centered timer">
          O token expira em {{ timeFormated }}
        </div>
        <div class="row justify-content-center">
          <div class="col-10 col-sm-10 col-md-7 col-lg-4">
            <div class="form-group">
              <label>Token</label>
              <input
                type="text"
                class="form-control"
                v-model="token"
                inputmode="numeric"
              />
            </div>
          </div>
        </div>
        <div class="row justify-content-center">
          <div class="col-10 col-sm-10 col-md-4 col-lg-2">
            <button class="btn btn-sign white" @click="confirmToken">
              <i class="fas fa-check"></i>Confirmar
            </button>
          </div>
        </div>
      </div>
      <div v-if="step == 3 && signatureUserSent">
        <div class="row justify-content-center">
          <div class="col-10 col-sm-10 col-md-9 col-lg-6">
            <p class="text-title">
              {{ signatureUserSent.signature_batch.name }}
            </p>
            <p class="text">
              Prezado(a)
              <span>{{ signatureUserSent.user.name }}</span
              >!
            </p>
            <p class="text">
              Favor ler o documento abaixo e clicar no botão Assinar, ao fim da
              página:
            </p>
          </div>
        </div>
        <div class="row justify-content-center">
          <div class="col-12 col-sm-12 col-md-6 centered">
            <div class="row">
              <div class="col-5 offset-1">
                <button
                  class="item btn btn-danger btn-block"
                  @click="scale -= scale > 0.2 ? 0.1 : 0"
                >
                  <i class="fa fa-search-minus"></i>
                </button>
              </div>
              <div class="col-5">
                <button
                  class="item btn btn-primary btn-block"
                  @click="scale += scale < 2 ? 0.1 : 0"
                >
                  <i class="fa fa-search-plus"></i>
                </button>
              </div>
            </div>
            <div style="overflow-y: scroll; overflow-x: scroll" width="100%">
              <pdf
                :src="signatureUserSent.document_http"
                :page="page"
                style="width: 100%"
                :scale.sync="scale"
              ></pdf>
            </div>
            <div class="row">
              <div class="col-5 offset-1">
                <button
                  class="item btn btn-secondary btn-block"
                  @click="page -= 1"
                  :disabled="page - 1 == 0"
                >
                  <i class="fa fa-caret-left"></i>
                </button>
              </div>
              <div class="col-5">
                <button
                  class="item btn btn-secondary btn-block"
                  @click="page += 1"
                  :disabled="page == numPages"
                >
                  <i class="fa fa-caret-right"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="row justify-content-center mb-5 mt-4">
          <div class="col-10 col-sm-10 col-md-4 col-lg-2">
            <button class="btn btn-sign white" @click="sign">
              <i class="fas fa-file-signature"></i>Assinar
            </button>
          </div>
        </div>
      </div>
      <div class="centered" v-if="step == 4 && signatureUserSent">
        <div class="row justify-content-center">
          <div class="col-10 col-sm-10 col-md-9 col-lg-6">
            <p class="text-title">
              {{ signatureUserSent.signature_batch.name }}
            </p>

            <MultipleSignaturesTable v-if="multiple" :signatureUserSent="signatureUserSent"/>
            
            <p class="text">
              Prezado(a)
              <span>{{ signatureUserSent.user.name }}</span
              >!
            </p>
            <p class="text" v-if="signatureUserSent.detached != 1">
              Você assinou o seguinte documento:
            </p>
            <p class="text" v-else>Você assinou os seguintes documentos:</p>
            <p class="text" v-if="signatureUserSent.detached != 1">
              <i class="far fa-file-pdf red"></i>
              <span>{{ getDocumentName(signatureUserSent.document) }}</span>
            </p>
            <p
              class="text"
              v-else
              v-for="sign in signatureUserSents"
              :key="sign.id"
              @click="getPdfUnit(sign)"
              style="cursor: pointer"
            >
              <i class="far fa-file-pdf red"></i>
              <span>{{ sign.document_name }}</span>
            </p>
          </div>
        </div>
        <div class="row justify-content-center">
          <div class="col-10 col-sm-8 col-md-5 col-lg-4 border-confirm">
            <p class="confirm">
              <i class="far fa-check-circle"></i>
            </p>
            <p class="confirmation">Sua assinatura foi confirmada.</p>
            <p class="text-2">{{ formatDate() }}</p>
            <p class="text-2">
              Assinado por
              <span>{{ signatureUserSent.user.name }}</span>
            </p>
          </div>
        </div>

        <div
          class="row justify-content-center mt-5"
          v-if="signatureUserSent.detached != 1"
        >
          <div class="col-10 col-sm-10 col-md-5 col-lg-5">
            <a
              :href="signatureUserSent.document_http"
              target="_blank"
              class="btn btn-sign white"
            >
              <i class="fa fa-download">Baixar</i>
            </a>
          </div>
        </div>
        <div class="row justify-content-center mt-5" v-else-if="viewDoc">
          <div class="col-10 col-sm-10 col-md-5 col-lg-5">
            <a
              :href="viewDoc.document_http"
              target="_blank"
              class="btn btn-sign white"
            >
              <i class="fa fa-download">Baixar</i>
            </a>
          </div>
        </div>

        <div
          class="row justify-content-center mt-5 mb-5"
          v-if="signatureUserSent.detached != 1"
        >
          <div class="col-12 col-sm-12 col-md-6 centered">
            <div class="row">
              <div class="col-5 offset-1">
                <button
                  class="item btn btn-danger btn-block"
                  @click="scale -= scale > 0.2 ? 0.1 : 0"
                >
                  <i class="fa fa-search-minus"></i>
                </button>
              </div>
              <div class="col-5">
                <button
                  class="item btn btn-primary btn-block"
                  @click="scale += scale < 2 ? 0.1 : 0"
                >
                  <i class="fa fa-search-plus"></i>
                </button>
              </div>
            </div>
            <div style="overflow-y: scroll; overflow-x: scroll" width="100%">
              <pdf
                :src="signatureUserSent.document_http"
                :page="page"
                style="width: 100%"
                :scale.sync="scale"
              ></pdf>
            </div>
            <div class="row">
              <div class="col-5 offset-1">
                <button
                  class="item btn btn-secondary btn-block"
                  @click="page -= 1"
                  :disabled="page - 1 == 0"
                >
                  <i class="fa fa-caret-left"></i>
                </button>
              </div>
              <div class="col-5">
                <button
                  class="item btn btn-secondary btn-block"
                  @click="page += 1"
                  :disabled="page == numPages"
                >
                  <i class="fa fa-caret-right"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
        <div
          class="row justify-content-center"
          style="margin-top: 15px"
          v-if="openViewPDF && signatureUserSent.detached == 1"
        >
          <div class="col-12 col-sm-12 col-md-6 centered">
            <div class="row">
              <div class="col-5 offset-1">
                <button
                  class="item btn btn-danger btn-block"
                  @click="scale -= scale > 0.2 ? 0.1 : 0"
                >
                  <i class="fa fa-search-minus"></i>
                </button>
              </div>
              <div class="col-5">
                <button
                  class="item btn btn-primary btn-block"
                  @click="scale += scale < 2 ? 0.1 : 0"
                >
                  <i class="fa fa-search-plus"></i>
                </button>
              </div>
            </div>
            <div style="overflow-y: scroll; overflow-x: scroll" width="100%">
              <pdf
                :key="componentKey"
                v-if="openViewPDF"
                :src="viewDoc.document_http"
                :page="page"
                style="width: 100%"
                :scale.sync="scale"
              ></pdf>
            </div>
            <div class="row">
              <div class="col-5 offset-1">
                <button
                  class="item btn btn-secondary btn-block"
                  @click="page -= 1"
                  :disabled="page - 1 == 0"
                >
                  <i class="fa fa-caret-left"></i>
                </button>
              </div>
              <div class="col-5">
                <button
                  class="item btn btn-secondary btn-block"
                  @click="page += 1"
                  :disabled="page == numPages"
                >
                  <i class="fa fa-caret-right"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="centered" v-if="step == 5">
        <div class="message">
          <h1>Prazo para assinatura do documento expirado</h1>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import pdf from "pdfvuer";
import MultipleSignaturesTable from "../SignatureUser/MultipleSignaturesTable";
export default {
  data() {
    return {
      multiple: false,
      count: 0,
      scale: "page-width",
      signatureUserSent: "",
      openViewPDF: false,
      signatureUserSents: [],
      hash: "",
      confirm: {
        cpf: "",
        birthDate: "",
      },
      viewDoc: {},
      step: 1,
      token: "",
      timer: 0,
      timeFormated: "",
      timerActive: false,
      pdfdata: "",
      numPages: 0,
      page: 1,
      canceled_reason: "",
      componentKey: 0,
    };
  },
  computed: {
    readDocuments() {
      var result = this.count >= this.signatureUserSents.length;
      return !result;
    },
  },
  watch: {
    timer(newVal, oldVal) {
      if (newVal == 1 && timerActive) {
        clearInterval(this.timerRef);
        window.location.reload();
      }
      let minutes = Math.floor(this.timer / 60);
      let seconds = newVal % 60;
      this.timeFormated =
        minutes + ":" + (seconds < 10 ? "0" + seconds : seconds);
    },
  },
  methods: {
    getPdf() {
      var self = this;
      self.pdfdata = pdf.createLoadingTask(
        self.signatureUserSent.document_http
      );
      self.pdfdata.then((pdf) => {
        self.numPages = pdf.numPages;
      });
    },
    getPdfUnit(sign) {
      this.count = this.count + 1;
      var self = this;
      self.openViewPDF = false;
      self.page = 1;
      self.viewDoc = sign;
      self.pdfdata = pdf.createLoadingTask(sign.document_http);
      self.pdfdata.then((pdf) => {
        self.numPages = pdf.numPages;
      });
      self.openViewPDF = true;
      self.componentKey += 1;
    },
    formatDate(date) {
      return (
        "Data: " +
        moment(date).format("DD/MM/YYYY") +
        " - Horário: " +
        moment(date).format("H:mm:ss")
      );
    },
    startCounting() {
      const self = this;
      self.timer = 3599;
      self.timerActive = true;
      self.timerRef = setInterval(function () {
        self.timer--;
      }, 1000);
    },
    getDocumentName(path) {
      const pathSplited = path.split("/");
      return pathSplited[pathSplited.length - 1];
    },
    getSignatureUserSent() {
      const self = this;
      const api =
        self.$store.state.api +
        "signatureusersent/byHash/" +
        self.hash +
        "?with[]=signature_batch&with[]=user";
      self.$http
        .get(api)
        .then((response) => {
          if (!response.data.data[0]) {
            self.step = response.data.data.step;
            if (self.step == 99) {
              self.canceled_reason = response.data.data.canceled_reason;
            }
          } else {
            self.signatureUserSent = response.data.data[0];
            self.signatureUserSents = response.data.others;
            if (self.signatureUserSent.signed) {
              self.step = 4;
            }
            if(self.signatureUserSent.signature_batch.is_multiple){
            self.multiple = true;
            }

            // if (self.signatureUserSent.detached >= 1) {
            //   self.step = 6;
            // }
          }
        })
        .catch((error) => {
          self.$message("Erro", error.response.data, "error");
        });
    },
    generateToken() {
      const self = this;
      const api = self.$store.state.api + "signatureusersent/generateToken";
      self.$http
        .post(api, {
          hash: self.hash,
          cpf: self.confirm.cpf,
          birthDate: self.confirm.birthDate,
        })
        .then((response) => {
          self.step = 2;
          self.startCounting();
        })
        .catch((error) => {
          self.$message("Erro", error.response.data, "error");
        });
    },
    confirmToken() {
      const self = this;
      const api = self.$store.state.api + "signatureusersent/confirmToken";

      self.$http
        .post(api, {
          hash: self.hash,
          token: self.token,
        })
        .then((response) => {
          self.timerActive;
          clearInterval(self.timerRef);
          if (self.signatureUserSent.detached >= 1) {
            self.step = 6;
          } else {
            self.step = 3;
          }
          self.getPdf();
        })
        .catch((error) => {
          self.$message("Erro", error.response.data, "error");
        });
    },
    sign() {
      const self = this;
      const api = self.$store.state.api + "signatureusersent/sign";

      swal({
        title: "Geolocalização",
        text:
          "Para assinar o documento, é necessário permitir a utilização da geolocalização do dispositivo",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#DD6B55",
        confirmButtonText: "Ok, entendi!",
        showLoaderOnConfirm: true,
        buttons: {
          catch: {
            text: "Cancelar",
            value: "cancel",
            className: "btn-danger",
          },
          confirm: {
            text: "Ok, entendi!",
            value: "confirm",
          },
        },
      }).then((value) => {
        switch (value) {
          case "cancel":
            location.reload();

          case "confirm":
            if (navigator.geolocation) {
              navigator.geolocation.getCurrentPosition(
                function (pos) {
                  console.log(pos);
                  $("#page_loader").show();
                  self.$http
                    .post(api, {
                      hash: self.hash,
                      token: self.token,
                      geolocation: {
                        latitude: pos.coords.latitude,
                        longitude: pos.coords.longitude,
                      },
                      cpf: self.confirm.cpf,
                      birthDate: self.confirm.birthDate.substring(0, 10),
                    })
                    .then((response) => {
                      self.getPdf();
                      self.step = 4;
                      self.signatureUserSent = self.getSignatureUserSent();
                      $("#page_loader").hide();
                    })
                    .catch((error) => {
                      $("#page_loader").hide();
                      self.$message("Erro", error.response.data, "error");
                    });
                },
                function (error) {
                  if (error.code == error.PERMISSION_DENIED)
                    self.showPermissionDeniedSwal();
                }
              );
            } else {
              alert("Geolocalização não é suportada neste navegador");
              return false;
            }
            break;
        }
      });
      // }
    },
    showPermissionDeniedSwal() {
      swal({
        title: "Permissão para acessar geolocalização",
        text:
          "Para realizar a assinatura, você precisa liberar o acesso à geolocalização, siga estes passos para desbloquear: \n\n" +
          "1 - Certifique-se de abrir esta página utilizando o browser/navegador e clique em Configurações\n" +
          "2 - Clique em Configurações do site\n" +
          "3 - Clique em Local\n" +
          "4 - Na lista de bloqueados procure por https://estapar.innovsign.com.br clique sobre ele e na sequencia clique em Limpar e Redefinir \n" +
          "5 - Tente novamente",
        type: "info",
        closeOnConfirm: true,
      });
    },
  },
  mounted: function () {
    this.hash = this.$route.params.hash;
    if (this.hash) {
      this.getSignatureUserSent();
    }
    // const self = this;
    // setTimeout(function() {
    //     self.step = 3;
    //     self.getPdf();
    // }, 1500);
  },
  components: {
    MultipleSignaturesTable,
    pdf,
  },
};
</script>

<style scoped>
.message {
  margin-top: 100px;
}
.form-control {
  border: 2px solid #03a830 !important;
  outline: 0 !important;
  box-shadow: none !important;
  color: #232323 !important;
  border-radius: 0.25rem !important;
  display: block;
  width: 100%;
  height: calc(1.5em + 0.75rem + 2px);
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #ced4da;
}

.date-time-picker .field-input {
  border: 2px solid green;
  border-radius: 6px;
  height: 30px;
  background-color: transparent;
}
</style>


// WEBPACK FOOTER //
// src/components/SignatureUser/Sign.vue